import { createSlice } from "@reduxjs/toolkit";
import { userPreferencesDefaults } from "common/user-preferences-defaults";
import { publishToMessageBus, USER_SETTINGS_CHANGED } from "common/ins-message-bus";
import { getUserPreferencesRaw, usePatchUserPreferences } from "./api";
export { getUserPreferencesRaw, usePatchUserPreferences } from "./api";
export { mapBackendUserPreferencesToUserPreferences } from "./mapper";
const initialState = {
    current: {
        allocationKey: userPreferencesDefaults.allocationKey,
        commitmentCalculation: userPreferencesDefaults.commitmentCalculation,
        dateFormat: userPreferencesDefaults.dateFormat,
        enableJSONEditing: userPreferencesDefaults.enableJSONEditing,
        negativeNumberFormat: userPreferencesDefaults.negativeNumberFormat,
        region: userPreferencesDefaults.region,
        unitOfArea: userPreferencesDefaults.unitOfArea
    },
    draft: null
};
const slice = createSlice({
    extraReducers: (builder) => {
        builder.addMatcher(getUserPreferencesRaw, (state, action) => {
            if (action.payload) {
                Object.assign(state.current, action.payload);
                publishToMessageBus(USER_SETTINGS_CHANGED, action.payload);
            }
        })
            .addMatcher(usePatchUserPreferences, (state, action) => {
            if (action.payload) {
                Object.assign(state.current, action.payload);
                publishToMessageBus(USER_SETTINGS_CHANGED, action.payload);
            }
        });
    },
    initialState,
    name: "settingsReducers",
    reducers: {
        changeSettings: (state, action) => {
            if (action.payload) {
                Object.assign(state.current, action.payload);
            }
        },
        clearDraftSettings: (state) => {
            state.draft = null;
        },
        commitDraftSettings: (state) => {
            if (state.draft) {
                Object.assign(state.current, state.draft);
                state.draft = null;
            }
        },
        initDraftSettings: (state) => {
            state.draft = { ...state.current };
        },
        updateDraftSettings: (state, action) => {
            if (state.draft) {
                state.draft = { ...state.draft, ...action.payload };
            }
        }
    }
});
export const settingsReducers = slice.reducer;
export const { changeSettings, clearDraftSettings, commitDraftSettings, initDraftSettings, updateDraftSettings } = slice.actions;
